import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesPageHeader from '../../pages/markets/pages/futures/header';
import AdWithPlaceholder from '../../molecules/ad-with-placeholder';
import AllNewsSection from '../../collection-templates/AllNewsSection';
import LiveTVWidget from '../../collection-templates/videos-list-collection/live-tv-widget';
import MailmodoNewsLetter from '../../molecules/newsletter/mailmodo-news-letter';
import JoinOfficialChannelsStocks from '../../pages/markets/component/join-official-channels-stocks';
import ResearchReportsAlternate from '../../pages/markets/component/research-reports-alternate';
import MarketsNewsFutures from '../../pages/markets/component/markets-news-futures';
import OpenInterestFutures from '../../pages/markets/component/open-interest-futures';
import GreatestPremiumDiscountFutures from '../../pages/markets/component/greatest-premium-discount-futures';
import RolloverFutures from '../../pages/markets/component/rollover-futures';
import AccumulationTableFutures from '../../pages/markets/component/accumulation-table-futures';
import MostActiveTableFutures from '../../pages/markets/component/most-active-table-futures';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import SectoralMovementsFutures from '../../pages/markets/component/sectoral-movements-futures';
import FuturesGraphWidget from '../../pages/markets/component/futures-graph-widget';
import { WithLazy } from '@quintype/components';
import '../../pages/markets/pages/futures/futures.m.css';

const FuturesContractFull = (props) => {
  const [news, setNews] = useState({});
  const [marketNews, setMarketNews] = useState({});
  const queryClient = new QueryClient();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getAllNews = async () => {
      const response = await fetch('/api/v1/collections/all-news-module');
      const data = await response;
      const dataInJson = await data.json();

      setNews(dataInJson);
    };
    getAllNews();
  }, []);

  useEffect(() => {
    const getMarketNews = async () => {
      setIsLoading(true);
      const response = await fetch('/api/v1/collections/markets');
      const data = await response.json();
      setMarketNews(data);
      setIsLoading(false);
    };
    getMarketNews();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        <div styleName="background-container gap-adjustments">
          <div className="container">
            <FuturesPageHeader {...props} />
          </div>
          <div styleName="container-gap-top-alt container-gap-bottom" className="container">
            <FuturesGraphWidget />
          </div>
        </div>
        <WithLazy>
          {() => (
            <div styleName="minor-major-fold gap-adjustments" className="container">
              <OpenInterestFutures />
              <MarketsNewsFutures newsData={marketNews} loadingStatus={isLoading} />
            </div>
          )}
        </WithLazy>
        <WithLazy>
          {() => (
            <div styleName="three-grid-fold gap-adjustments" className="container">
              <GreatestPremiumDiscountFutures />
              <RolloverFutures />
              <div styleName="video-newsletter-container" className="video-social-widgets">
                <LiveTVWidget />
                <MailmodoNewsLetter
                  title="All You Need To Know"
                  heading="Once Every Morning"
                  footerText1="We Promise. No Spam !"
                  footerText2="View All Newsletters"
                  page="market"
                />
              </div>
            </div>
          )}
        </WithLazy>

        <WithLazy>
          {() => (
            <div styleName="major-minor-fold gap-adjustments" className="container">
              <ResearchReportsAlternate />
              <div>
                <JoinOfficialChannelsStocks />
              </div>
            </div>
          )}
        </WithLazy>
        <WithLazy>
          {() => (
            <div styleName="background-container">
              <div styleName="gap-adjustments container-gap-top" className="container">
                <AccumulationTableFutures limit={10} external={false} />
              </div>

              <div styleName="gap-adjustments " className="container">
                <MostActiveTableFutures limit={10} external={false} />
              </div>

              <div styleName="gap-adjustments " className="container">
                <SectoralMovementsFutures />
              </div>

              <div styleName="gap-adjustments  container-gap-bottom" className="container">
                <FuturesAndOptionsFaq />
              </div>
            </div>
          )}
        </WithLazy>
      </>
    </QueryClientProvider>
  );
};

export default FuturesContractFull;
